/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {ReactNode, useCallback} from "react";
import {useGetCmsPageLazyQuery} from "@/generated/graphql";
import {useSnackbar} from "notistack";
import jsonToJsx from "@/app/utils/jsonToJsx";

/**
 * Connector for getting CMS page data
 */
const useGetCmsPage = (skeleton?:ReactNode) => {
    const [getCmsPageQueryHandler, {data, loading, error}] = useGetCmsPageLazyQuery();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const getCmsPageTrigger = useCallback((identifier:string) => {
        getCmsPageQueryHandler({
            variables: {
                identifier: identifier
            }
        }).catch((reason) => {
            console.error(reason);
            enqueueSnackbar('Error getting CMS block', {variant: "error"});
        });
    }, []);

    let cmsPageContent = skeleton ?? <></>;
    let cmsPageData:any = [];

    if(!loading && !error) {
        if(data && data.cmsPage) {
            cmsPageData = data.cmsPage
            const json = data.cmsPage.content_json ?? data.cmsPage.content ?? '{}';
            cmsPageContent = jsonToJsx(json);
        }
    }

    if(error) {
        cmsPageData.error = true;
    }

    return {getCmsPageTrigger, loading, cmsPageContent, cmsPageData, error};
}

export default useGetCmsPage;